import { useState } from 'react';
import { Button as MuiButton } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { Confirm, Toolbar, useRecordContext, useSaveContext } from 'react-admin';
import { ADS_JOB_ENABLE_CONFIRM_TEXT } from '../../../../../helpers/adsJobsConstants';

export const AdsJobsToolbar = () => {
  const { save } = useSaveContext();
  const { handleSubmit } = useFormContext();
  const record = useRecordContext();
  const [pending, setPending] = useState(null);

  const handleSave = handleSubmit((values) => {
    if (record && record.enabled === false && values.enabled === true) {
      setPending(values);
    } else {
      save(values);
    }
  });

  return (
    <Toolbar>
      <MuiButton variant="contained" onClick={handleSave}>Save</MuiButton>
      <Confirm
        isOpen={!!pending}
        title="Turn the job on?"
        content={ADS_JOB_ENABLE_CONFIRM_TEXT}
        onConfirm={() => {
          save(pending);
          setPending(null);
        }}
        onClose={() => setPending(null)}
      />
    </Toolbar>
  );
};
